import { render } from "./UploadDataset.vue?vue&type=template&id=314329ee&scoped=true"
import script from "./UploadDataset.vue?vue&type=script&lang=js"
export * from "./UploadDataset.vue?vue&type=script&lang=js"

import "./UploadDataset.vue?vue&type=style&index=0&id=314329ee&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314329ee"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBtn,QIcon,QInnerLoading});qInstall(script, 'directives', {ClosePopup});
